/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Radio from 'backbone.radio';

import PageableCollection from '@/backbone/PageableCollection';
import ButtonCell from '@/backgrid/ButtonCell';
import StringCell from '@/backgrid/StringCell';
import TruncateStringCell from '@/backgrid/TruncateStringCell';
import { DateCell } from '@/backgrid/MomentCell';
import GridView from '@/views/GridView';

const InProgressOrdersGridView = GridView.extend({
  initialize() {
    this.options.columns = [
      {
        name: 'id',
        label: 'Order ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false
      },
      {
        name: 'formName',
        label: 'Order Type',
        cell: StringCell,
        headerCell: 'custom',
        width: 30,
        editable: false
      },
      {
        name: 'status',
        label: 'Order Status',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false
      },
      {
        name: 'submittedOn',
        label: 'Submitted On',
        cell: DateCell,
        headerCell: 'custom',
        width: 25,
        editable: false,
        direction: 'ascending'
      },
      {
        name: 'openButton',
        label: '',
        width: 10,
        cell: ButtonCell.extend({
          name: 'Open',
          buttonClass: 'btn-sm btn-outline-primary',
          onClick: this.viewDetails.bind(this)
        }),
        editable: false,
        sortable: false
      }
    ];
    this.options.collection = new PageableCollection(this.model.get('data'), { pageSize: 5 });
    this.options.emptyText = 'No In-Progress Orders';
  },

  viewDetails(e, model) {
    e.preventDefault();
    Radio.channel('navigate').request('show:order', model.get('id'));
  }
});

export default InProgressOrdersGridView;
